require('./ProgramHeader_Complex.scss');

const b = require('app/www/libs/b')('program-header');

const React = require('react');
const PropTypes = require('prop-types');

const {withI18n} = require('app/www/components/contexts/I18n');

const Button = require('app/www/components/blocks/Button/Button');
const ProgramDescription = require('app/www/components/blocks/ProgramDescription/ProgramDescription');
const ProgramHeader = require('app/www/components/blocks/ProgramHeader/ProgramHeader');
const ProgramRating = require('app/www/components/blocks/ProgramRating/ProgramRating');
const TrailerSchemaOrg = require('app/www/components/blocks/TrailerSchemaOrg/TrailerSchemaOrg');
const Video = require('app/www/components/blocks/Video/Video');
const Ua = require('app/www/components/blocks/Ua/Ua');

const {MIN_VOTES} = require('app/www/constants/programRating');

class ProgramHeader_Complex extends React.PureComponent {

    constructor(props) {
        super(props);

        this.state = {};

        this._onClickTrailer = this._onClickTrailer.bind(this);
    }

    render() {
        const {video} = this.state;
        const {
            age,
            type,
            i18n,
            year,
            cover,
            genre,
            title,
            trailer,
            eventId,
            programId,
            countries,
            firstEvent,
            isFavorite,
            channelsId,
            description,
            ottSelection,
            originalTitle,
            episodesLength,
            mainReleaseDate,
            isLayoutColumnsSmall,
            onClickButtonTrailer,
            onClickButtonEpisodes,
            buttonBroadcastingProps,
            onClickDescriptionButton,
            onClickButtonWatchOnline,
            onClickButtonBroadcasting,
            onClickButtonWatchEpisode,
        } = this.props;

        const rating = this.props.rating || {};
        const country = `${countries[0] || ''}${countries.length > 1 ? '...' : ''}`;
        const meta = [type.name, genre, country, year].filter(Boolean);

        const buttonProps = {
            mods: {
                size: isLayoutColumnsSmall ? 'xl' : '2xl',
                pin: 'circle',
                icon: 'bright',
                'only-icon': true,
            },
            icon: {
                size: isLayoutColumnsSmall ? 'm' : 'l',
                play: true,
            },
        };

        const trailerSchemaOrgProps = {
            title,
            trailer,
        };

        const coverStyle = {
            backgroundImage: `url('${cover}')`,
        };

        const videoProps = trailer && {
            isTrailer: true,
            src: trailer.video,
            allowFullScreen: true,
            allow: 'autoplay; encrypted-media',
        };

        const programRatingProps = {
            mods: {
                size: 's',
            },
            rate: rating.rate,
        };

        const programHeaderProps = {
            type,
            title,
            eventId,
            programId,
            channelsId,
            isFavorite,
            ottSelection,
            episodesLength,
            isLayoutColumnsSmall,
            onClickButtonTrailer,
            onClickButtonEpisodes,
            buttonBroadcastingProps,
            onClickButtonWatchOnline,
            onClickButtonBroadcasting,
            onClickButtonWatchEpisode,
        };

        const programDescriptionProps = Object.assign({
            mods: {
                type: 'header',
            },
            description,
            lineNumber: 3,
            lineHeight: 21,
        }, Ua.displayWidth && !isLayoutColumnsSmall && {
            forceButton: true,
            callback: onClickDescriptionButton,
            buttonText: i18n.get('program-description.button-header'),
        });

        return (
            <div className={b({complex: true})}>
                <div className={b('content')}>
                    {trailer && !video && (
                        <div
                            className={b('trailer')}
                            style={coverStyle}
                            onClick={this._onClickTrailer}
                        >
                            {Ua.displayWidth && <Button {...buttonProps} />}
                            <span className={b('trailer-text')}>{i18n.get('button.trailer')}</span>
                            <TrailerSchemaOrg {...trailerSchemaOrgProps} />
                        </div>
                    )}
                    {video && (
                        <Video className={b('video')} {...videoProps} />
                    )}
                    {!trailer && (
                        <div
                            className={b('cover')}
                            style={coverStyle}
                            itemProp="image" itemScope itemType="http://schema.org/ImageObject"
                        >
                            <meta itemProp="url" content={`https:${cover}`} />
                        </div>
                    )}
                    <div className={b('info')}>
                        {rating.votes >= MIN_VOTES && (
                            <span className={b('rating')}>
                                <ProgramRating {...programRatingProps} />
                            </span>
                        )}
                        {meta.length > 0 && (
                            <span className={b('meta')}>
                                {meta.map(item => (
                                    <span key={item} className={b('meta-item')}>{item}</span>
                                ))}
                            </span>
                        )}
                        {age > 0 && (
                            <span className={b('age')}>{age}+</span>
                        )}
                        <ProgramHeader {...programHeaderProps}>
                            {firstEvent && (
                                <div className={b('first-event')}>
                                    {firstEvent}
                                </div>
                            )}
                            {description && (
                                <div className={b('description')}>
                                    <ProgramDescription {...programDescriptionProps} />
                                </div>
                            )}
                        </ProgramHeader>
                        <meta itemProp="alternativeHeadline" content={originalTitle} />
                        <meta itemProp="dateCreated" content={mainReleaseDate} />
                    </div>
                </div>
            </div>
        );
    }

    /**
     * @private
     */
    _onClickTrailer() {
        this.setState({
            video: true,
        });
    }

}

ProgramHeader_Complex.propTypes = {
    programId: PropTypes.number,
    isFavorite: PropTypes.bool,
    cover: PropTypes.string,
    rating: PropTypes.object,
    title: PropTypes.string,
    trailer: PropTypes.object,
    type: PropTypes.object,
    genre: PropTypes.string,
    countries: PropTypes.arrayOf(PropTypes.string),
    year: PropTypes.number,
    age: PropTypes.number,
    description: PropTypes.string,
    firstEvent: PropTypes.string,
    ottSelection: PropTypes.object,
    episodesLength: PropTypes.number,
    isLayoutColumnsSmall: PropTypes.bool,
    buttonBroadcastingProps: PropTypes.object,
    onClickButtonTrailer: PropTypes.func,
    onClickDescriptionButton: PropTypes.func,
    onClickButtonEpisodes: PropTypes.func,
    onClickButtonWatchOnline: PropTypes.func,
    onClickButtonBroadcasting: PropTypes.func,
    onClickButtonWatchEpisode: PropTypes.func,
};

module.exports = withI18n(ProgramHeader_Complex);
